import { render } from "./NotFound.vue?vue&type=template&id=ee6a8e6c&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=ee6a8e6c&lang=css"
import "./NotFound.vue?vue&type=style&index=1&id=ee6a8e6c&scoped=true&lang=css"
import "@/assets/css/style_error_page.css?vue&type=style&index=2&id=ee6a8e6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee6a8e6c"]])

export default __exports__